/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React, {
  useContext, useMemo, useState, useRef,
} from 'react';
import PropTypes from 'prop-types';

const SignaturePadContext = React.createContext();

/**
 * Custom useSitePackageProvider Component
 * @returns {unknown}
 */
export const useSignaturePadProvider = () => useContext(SignaturePadContext);

export function SignaturePadProvider({ children }) {
  const [drawPadChanges, setDrawPadChanges] = useState([]);
  const [imagesData, setImagesData] = useState(null);
  const [navigationAction, setNavigationAction] = useState('touch');
  const signaturePadsReference = useRef([]);
  const [color, setColor] = useState('#FF0000');

  const values = useMemo(() => ({
    drawPadChanges,
    setDrawPadChanges,
    color,
    setColor,
    navigationAction,
    setNavigationAction,
    imagesData,
    setImagesData,
    signaturePadsReference,
  }), [drawPadChanges, setDrawPadChanges, color, setColor, navigationAction, setNavigationAction, imagesData, setImagesData, signaturePadsReference]);

  return (
    <SignaturePadContext.Provider value={values}>
      {children}
    </SignaturePadContext.Provider>
  );
}

SignaturePadProvider.propTypes = {
  children: PropTypes.object.isRequired,
};
